import { Helmet } from "react-helmet";
import PoliciesLayout from "../section/policies/policy-layout";
import jsonData from '../data/policies/en/privacyPolicy.json';

const PrivacyPolicyPage = () => {
    <Helmet>
        <title>Privacy Policy | Digital Tourism Sri Lanka</title> 
        <meta name="description" content="Review Digital Tourism’s privacy policy to understand how we collect, protect, and use data across our websites, apps, and digital travel platforms." />
        <meta name="keywords" content="Digital Tourism privacy policy, data protection Sri Lanka, travel tech privacy, tourism data security" />
    </Helmet>

    return (
        <>
            <PoliciesLayout json={jsonData}/>
        </>
    );
}

export default PrivacyPolicyPage;